import { DotsInputMask, IDotsInputMaskProps } from "dots-ui/dotsInputMask";
import { useMemo } from "react";
import { getValueTooltip } from "../../../../utils";

interface IAvisInputMaskProps<T> extends IDotsInputMaskProps<T> {
  title?: string;
}
export function AvisInputMask<T = object>(
  props: Readonly<IAvisInputMaskProps<T>>,
) {
  const { title, ...restProps } = props;

  const tooltipValue = useMemo(() => {
    return getValueTooltip(title, props.bag, props.bagField);
  }, [props.bag, props.bagField, title]);

  return (
    <div title={tooltipValue}>
      <DotsInputMask<T> spacing="small" {...restProps} />
    </div>
  );
}
